import { $createEl, createStyleSector } from "./domHelpers";
import { properties } from "../lib/defaults";
import icons from "../assets/icons";

const frame = $createEl("iframe", "", {
  id: "frame",
  class: "frame",
  draggable: "false",
});

const devices = $createEl("div", "", {
  id: "devices",
});

const topBar = $createEl("div", [devices], {
  id: "top-bar",
  class: "top-bar",
});

const blocksContainer = $createEl("div", "", {
  id: "components",
  class: "components show",
  draggable: "false",
});

const htmlContainer = $createEl("textarea", "", {
  id: "html",
  spellcheck: "false",
  cols: "30",
  rows: "10",
});

const cssContainer = $createEl("textarea", "", {
  id: "css",
  spellcheck: "false",
  cols: "30",
  rows: "10",
});

const codeContainer = $createEl("div", [htmlContainer, cssContainer], {
  id: "code",
});

const layers = $createEl("div", [], {
  id: "layers",
});

const toolbar = $createEl("div", "", {
  id: "toolbar",
});

const sectors: HTMLElement[] = [];

Object.keys(properties).forEach((key) => {
  sectors.push(createStyleSector(key, properties[key]));
});

const backIcon = $createEl("div", icons.back, { id: "back-icon" });

export {
  frame,
  topBar,
  blocksContainer,
  codeContainer,
  htmlContainer,
  cssContainer,
  layers,
  toolbar,
  sectors,
  backIcon,
};
